export const USERS = 'users';

export const USERS_ACTIONS_NAME = {
  getUsers: `${USERS}/getUsers`,
};

export const USERS_MUTATIONS_NAME = {
  setUsers: `${USERS}/setUsers`,
};

export const USERS_GETTERS_NAME = {
  getUsers: `${USERS}/getUsers`,
};
